import React, { ReactNode, useMemo } from 'react';

import { FormComponent, UiComponent } from 'components';
import { tableWrap, tableToolbar } from 'styles/table';
import { ICollection, IPageOption } from 'types';
import { BsPlusLg } from 'react-icons/bs';
import useModal from 'hooks/useModal';
import CollectionForm from '../Form';
import ContentsManage from '../Contents';
import { getTypeText } from '../utils';
import dayjs from 'dayjs';
import { BiPencil } from 'react-icons/bi';

const COLS: string[] = [
  'ID',
  '컬렉션명',
  '타이틀',
  '서브타이틀',
  '유형',
  '콘텐츠 구성',
  // '수정하기',
  '등록일',
];

interface Props {
  pageOption: IPageOption;
  handlePage: (option: IPageOption) => void;
  data: ICollection[];
  totalPage: number;
  toolbar?: ReactNode;
}

function List({ data, toolbar, ...pageOptions }: Props) {
  const { handleModal } = useModal();

  const handleCollectionModal = (collection: ICollection | null) => {
    handleModal('', <CollectionForm collection={collection} />, <></>);
  };

  const handleContentsManage = (id: number) => {
    handleModal('', <ContentsManage id={id} />, <></>);
  };

  const renderer: Record<
    (typeof COLS)[number],
    (data: ICollection & { row: number }) => ReactNode
  > = useMemo(
    () => ({
      ID: ({ id }: ICollection) => <>{id}</>,
      컬렉션명: (collection: ICollection) => (
        <p
          css={{
            textAlign: 'left',
            cursor: 'pointer',
            textDecoration: 'underline',
          }}
          title="컬렉션 메타 정보 수정"
          onClick={() => handleCollectionModal(collection)}
        >
          {collection.name}
          <span css={{ marginLeft: '4px' }}>
            <BiPencil size={11} />
          </span>
        </p>
      ),
      타이틀: ({ title }: ICollection) => (
        <p css={{ textAlign: 'left' }}>{title || '-'}</p>
      ),
      서브타이틀: ({ subTitle }: ICollection) => <>{subTitle || '-'}</>,
      유형: ({ type }: ICollection) => <>{getTypeText(type)}</>,
      // 수정하기: (collection: ICollection) => (
      //   <UiComponent.Button
      //     variant="contained"
      //     color="primary"
      //     onClick={() => handleCollectionModal(collection)}
      //   >
      //     수정하기
      //   </UiComponent.Button>
      // ),
      '콘텐츠 구성': ({ id }: ICollection) => (
        <UiComponent.Button
          variant="contained"
          color="primary"
          onClick={() => handleContentsManage(id)}
        >
          콘텐츠 담기
        </UiComponent.Button>
      ),

      등록일: ({ createdAt }: ICollection) => (
        <>{dayjs(createdAt).format('YYYY-MM-DD HH:mm')}</>
      ),
    }),
    [],
  );

  return (
    <UiComponent.Box>
      <div css={tableToolbar}>
        {toolbar ?? <div />}
        <div>
          <UiComponent.Button
            variant="contained"
            color="primary"
            onClick={() => handleCollectionModal(null)}
            css={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: '0 4px',
            }}
          >
            <BsPlusLg size={15} />
            <p css={{ fontSize: '14px' }}>컬렉션 추가</p>
          </UiComponent.Button>
          <FormComponent.Select
            css={{ width: '90px' }}
            options={[
              { name: '20', value: '20' },
              { name: '50', value: '50' },
              { name: '100', value: '100' },
            ]}
          />
        </div>
      </div>
      <div css={tableWrap}>
        <UiComponent.Table cols={COLS} renderer={renderer} data={data} sticky />
      </div>
      <UiComponent.Pagination {...pageOptions} />
    </UiComponent.Box>
  );
}

export default List;
